import {Component} from '@angular/core';
import {CorePage} from "../../../core/page/core-page/core.page";
import {ActivatedRoute, Router} from "@angular/router";
import {DashboardService} from "../../service/dashboard.service";
import {
  ContractInsurableObjectType,
  ContractsRequestDto,
  ContractsRuntimeDto, ContractsRuntimeGroupDto, ContractsRuntimeInsuranceDto, ContractsRuntimeObjectDto,
  ContractStatusEnum
} from "../../../cross/contracts/types/contracts.types";
import {SelectButtonChangeEvent, SelectButtonOptionClickEvent} from "primeng/selectbutton";
import {MultiSelectSelectAllChangeEvent} from "primeng/multiselect";
import {Subscription} from "rxjs";


@Component({
  selector: 'ds-contracts-page',
  templateUrl: 'contracts.page.html',
  styleUrls: ['./contracts.page.scss']
})
export class ContractsPage extends CorePage {

  override defaultLabel: string = "Home";
  activeIndex: number = 0;
  contractsRuntime: ContractsRuntimeDto | undefined;
  displayValue: string = 'list';
  selectedCategory: ContractsRuntimeGroupDto[] | undefined;
  selectedStatusOptions: { statusName: string, statusValue: number } | undefined =
    {statusName: 'Aktiv', statusValue: ContractStatusEnum.active};
  selectedInsurableObjectMap: Map<number, ContractsRuntimeObjectDto> | undefined;
  selectAll: boolean = false;
  uiContracts: ContractsRuntimeInsuranceDto[] | undefined = [];

  displayOptions: { icon: string, displayValue: string }[] = [
    {icon: 'pi pi-table', displayValue: 'list'},
    {icon: 'pi pi-list', displayValue: 'table'}
  ]
  statusOptions: { statusName: string, statusValue: number }[] = [
    {statusName: 'Alle', statusValue: ContractStatusEnum.all},
    {statusName: 'Aktiv', statusValue: ContractStatusEnum.active},
    {statusName: 'Inaktiv', statusValue: ContractStatusEnum.inactive},
    {statusName: 'In Bearbeitung', statusValue: ContractStatusEnum.pending}
  ];
  uiInsurableObjects: ContractsRuntimeObjectDto[] | undefined;
  isNavigation: boolean | undefined; //if we are coming from outside

  dashboardContractSubscription: Subscription | undefined;

  constructor(
    protected router: Router,
    protected override route: ActivatedRoute,
    protected dashboardService: DashboardService
  ) {
    super(route);

  }

  override ngOnInit() {
    super.ngOnInit();

    const insurableObject = this.route.snapshot.queryParams['insurableObject'];
    const insurablePerson = this.route.snapshot.queryParams['insurablePerson'];
    const categoryId = this.route.snapshot.queryParams['categoryId'];

    const display = localStorage.getItem('contractDisplayType');
    if (display == 'table') {
      this.displayValue = 'table';
    } else {
      this.displayValue = 'list'
    }

    // load initial contracts

    // contracts data changed
    this.dashboardContractSubscription = this.dashboardService.dashboardSubject.subscribe(value => {
      this.contractsRuntime = value;
      this.uiContracts = this.contractsRuntime.contracts?.filter(item => item.notFullyManaged == false);

      // this.postProcessContracts();

      /*
      if (!this.contractsRuntime) {
        this.contractsRuntime = value;
      } else {

        // we might have started the contracts screen with a limited number of insurable objects and therefor would need to display
        // all whenever the selection was "cleared"
        if (this.contractsRuntime.insurableObjects && value.insurableObjects && value.insurableObjects.length > this.contractsRuntime.insurableObjects.length) {
          this.contractsRuntime = value;
        } else {
          this.contractsRuntime.contracts = value.contracts;
        }
      }
       */

      this.uiInsurableObjects = this.contractsRuntime.insurableObjects;

      if (!this.initialized) {
        if (insurableObject || insurablePerson) {
          this.isNavigation = true;
          const insurable = insurableObject ? insurableObject : insurablePerson;
          const find = this.contractsRuntime?.insurableObjects?.find(object => object.filterId == insurable);
          if (find) {
            this.uiInsurableObjects = [];
            this.uiInsurableObjects.push(find);
            this.handleInsurableObject(find);
          }
        } else if (categoryId) {
          const find = this.contractsRuntime?.groups?.find(object => object.id == categoryId);
          if (find) {
            if (!this.selectedCategory) {
              this.selectedCategory = [];
            }
            this.selectedCategory?.push(find);
          }
        }
      }
      this.busy = false;
      this.initialized = true;
    });

    let contractsRequestDto = this.createInitialRequest();
    this.handleStatusOptions(contractsRequestDto);
    if (insurableObject) {
      if (!contractsRequestDto.filterInsurableObjectIds) {
        contractsRequestDto.filterInsurableObjectIds = [];
      }
      contractsRequestDto.filterInsurableObjectIds?.push(insurableObject);
    }
    if (insurablePerson) {
      if (!contractsRequestDto.filterInsurablePersonsIds) {
        contractsRequestDto.filterInsurablePersonsIds = [];
      }
      contractsRequestDto.filterInsurablePersonsIds?.push(insurablePerson);
    }
    if (categoryId) {
      if (!contractsRequestDto.filterGroupIds) {
        contractsRequestDto.filterGroupIds = [];
      }
      contractsRequestDto.filterGroupIds?.push(+categoryId);
    }

    this.dashboardService.changeRequest(contractsRequestDto);


  }

  postProcessContracts() {
    const unmanagedContracts = this.contractsRuntime?.contracts?.filter(item => item.notFullyManaged == true);

    if (!unmanagedContracts) {
      return;
    }

    //TODO: Check for groups as well if any to remove from the filters up top!

  }

  initAgain() {
    this.dashboardService.changeRequest(this.createInitialRequest());
  }

  protected createInitialRequest(): ContractsRequestDto {

    return {
      includeContractPartnerData: true,
      includeContractDetails: false,
      includeInsurableObjects: true,
      filterStatusIds: [ContractStatusEnum.active],
    };
    // , ContractStatusEnum.pending

  }

  private ensureArrayAndPush<T>(array: T[] | undefined, value: T): T[] {
    if (!array) {
      array = [];
    }
    array.push(value);
    return array;
  }

  setFilter(): ContractsRequestDto {
    const contractsRequestDto = this.createInitialRequest();

    this.handleCategoryChange(contractsRequestDto);

    this.handleStatusOptions(contractsRequestDto);

    this.handleInsurable(contractsRequestDto);

    return contractsRequestDto;
  }

  handleFilters() {
    this.busy = true;

    let contractsRequestDto = this.setFilter();

    if (this.initialized) {
      this.dashboardService.changeRequest(contractsRequestDto);
    }
  }


  handleCategoryChange(contractsRequestDto: ContractsRequestDto) {
    this.selectedCategory?.forEach(category => {
      contractsRequestDto.filterGroupIds = this.ensureArrayAndPush(contractsRequestDto.filterGroupIds, category.id);
    });
  }

  handleStatusOptions(contractsRequestDto: ContractsRequestDto) {
    const allStatusIds = [
      ContractStatusEnum.pending,
      ContractStatusEnum.active,
      ContractStatusEnum.inactive,
    ];
    if (!this.selectedStatusOptions) {
      this.selectedStatusOptions = undefined;
    }

    if (!this.initialized && contractsRequestDto.filterStatusIds) {
      const isAllSelected =
        contractsRequestDto.filterStatusIds.length === allStatusIds.length &&
        allStatusIds.every(id => contractsRequestDto.filterStatusIds!.includes(id));

      this.selectedStatusOptions = isAllSelected
        ? this.statusOptions.find(opt => opt.statusValue === 3)!
        : this.statusOptions.find(option =>
          contractsRequestDto.filterStatusIds!.includes(option.statusValue)
        );
    }

    const options = Array.isArray(this.selectedStatusOptions)
      ? this.selectedStatusOptions
      : this.selectedStatusOptions
        ? [this.selectedStatusOptions]
        : [];

    contractsRequestDto.filterStatusIds = options.some(opt => opt.statusName === 'Alle')
      ? allStatusIds
      : options.map(opt => opt.statusValue as ContractStatusEnum);

    // if (contractsRequestDto.filterStatusIds.length === allStatusIds.length) {
    //   this.selectedStatusOptions = this.statusOptions.find(opt => opt.statusValue === 3)!;
    // }
  }

  handleInsurable(contractsRequestDto: ContractsRequestDto) {

    this.selectedInsurableObjectMap?.forEach(object => {
      if (object.objectType === ContractInsurableObjectType.OBJECT) {
        contractsRequestDto.filterInsurableObjectIds = this.ensureArrayAndPush(contractsRequestDto.filterInsurableObjectIds, object.filterId);
      } else if (object.objectType === ContractInsurableObjectType.PERSON || object.objectType === ContractInsurableObjectType.ME) {
        contractsRequestDto.filterInsurablePersonsIds = this.ensureArrayAndPush(contractsRequestDto.filterInsurablePersonsIds, object.filterId);
      }
    });
  }

  handleInsurableObject(contractsRuntimeObject: ContractsRuntimeObjectDto) {

    if (!this.selectedInsurableObjectMap) {
      this.selectedInsurableObjectMap = new Map<number, ContractsRuntimeObjectDto>();
    }
    const hasObject = this.selectedInsurableObjectMap?.has(contractsRuntimeObject.id);

    if (hasObject) {
      this.selectedInsurableObjectMap?.delete(contractsRuntimeObject.id);
    } else {
      this.selectedInsurableObjectMap?.set(contractsRuntimeObject.id, contractsRuntimeObject);
    }

    if (this.selectedInsurableObjectMap?.size == 0) {
      this.selectedInsurableObjectMap = undefined;
    }

    if (!this.initialized) {
      return;
    }

    this.handleFilters();
  }

  clearAllInsurableObjects() {
    this.selectedInsurableObjectMap = undefined;
    if (this.isNavigation) {
      this.isNavigation = false;
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {insurablePerson: null, insurableObject: null},
        queryParamsHandling: 'merge',
      });
    }
    this.handleFilters();
  }

  showContract(contract: ContractsRuntimeInsuranceDto) {
    this.router.navigate(['/ds/contract', contract.id, 'ds/contracts']);
  }

  onSelectAllCategory(event: MultiSelectSelectAllChangeEvent) {
    this.selectAll = event.checked;
    if (this.contractsRuntime?.groups) {
      this.selectedCategory = event.checked ? [...this.contractsRuntime.groups] : [];
    }
    this.handleFilters();
  }

  override ngOnDestroy() {
    super.ngOnDestroy();

    if (this.dashboardContractSubscription) {
      this.dashboardContractSubscription.unsubscribe();
    }

  }

  handleChangeDisplay(event: SelectButtonChangeEvent) {
    localStorage.setItem('contractDisplayType', event.value);
  }

}
